import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ContentsquareService } from './contentsquare.service';

/**
 * Story 50.6 — on every route whose page taints a document for analytics (`analytics-boundary.ts`).
 *
 * Without the Contentsquare tag in this document it allows the navigation. With it, it cancels
 * the in-app navigation and repeats it as a full page load, so the URL never reaches the tag's
 * history listeners. Angular updates the address bar only after guards pass
 * (`urlUpdateStrategy: 'deferred'`, the default), which is what makes the cancel clean.
 * List it FIRST in `canActivate`. Always `true` on the server.
 */
export const analyticsBoundaryGuard: CanActivateFn = (_route, state) => inject(ContentsquareService).admit(state.url);
